import React from 'react';
import Spinner from 'react-spinkit';
import {connect} from "react-redux";
import {compose} from "redux";
import {getUserWithCompany} from "../../actions/users";
import {withLoading2} from "./deferLoaderHoc";
import * as R from "ramda";
import * as PropTypes from "prop-types";

export class _UserCustomNoPopover extends React.PureComponent {
  render() {
    const { resource: { id, company = {}, ...user } } = this.props;

    if (!id) return null;

    const { dataItems = ['name'] } = this.props;
    const full_name = [user.firstname, user.lastname].filter(i => i).join(' ') || null;
    // Build child only if their key is present in the data items prop
    const filterDisplay = (key, value) => dataItems.includes(key) ? value : null;
    const name = full_name && filterDisplay('name', <React.Fragment>{full_name}</React.Fragment>);
    const companyname = filterDisplay('companyname', <React.Fragment>{company.companyname}</React.Fragment>);
    const email = filterDisplay('email', <span style={{fontWeight: 'initial'}}>{user.email}</span>);

    return (
      <span>
        {name}{name && companyname && ' - '}{companyname}{(name || companyname) && <br/>}
        {email}
      </span>
    );
  }
}

const mapState = (state, ownProps) => {
  const dataPath = R.append(ownProps.id, (ownProps.dataPath || ['users', 'data']));
  const user = R.path(dataPath, state);
  if (!user) return { resource: { id: ownProps.id }, cache: { loading: true } };

  // Attempt to retrieve an item's resource data, but fall back if it's a pure resource without cache metadata
  const user_resource = user.resource || user;
  const company = R.path(['companies', 'data', user.companyid, 'resource'], state);
  return {
    resource: {
      id: ownProps.id,
      ...user_resource,
      company,
    },
    cache: {
      loading: false
    }
  };
};

export const UserCustomNoPopover = compose(
  connect(mapState),
  withLoading2(
    ({ resource: { id } }, dispatch) => dispatch(getUserWithCompany(id)),
    () => <Spinner name='line-scale'/>,
    null
  )
)(_UserCustomNoPopover);

UserCustomNoPopover.propTypes = {
  id: PropTypes.string.isRequired,
  dataPath: PropTypes.arrayOf(PropTypes.string),
  dataItems: PropTypes.arrayOf(PropTypes.string),
};



// WEBPACK FOOTER //
// ./src/components/Boilerplate/UserCustomNoPopover.js